const { createAction } = require("../../helpers");
const {
  GET_ADDRESS,
  GET_ADDRESS_SUCCESS,
  GET_ADDRESS_ERROR,
  GET_ADDRESS_RESET,

  CREATE_ADDRESS,
  CREATE_ADDRESS_SUCCESS,
  CREATE_ADDRESS_ERROR,
  CREATE_ADDRESS_RESET,

  UPDATE_ADDRESS,
  UPDATE_ADDRESS_SUCCESS,
  UPDATE_ADDRESS_ERROR,
  UPDATE_ADDRESS_RESET,
} = require("./constants");

/**
 * @param {Array<string>} iatas
 * @return {Promise<*>}
 */
const getAddress = () => createAction(GET_ADDRESS);
const getAddressSuccess = (add) =>
  createAction(GET_ADDRESS_SUCCESS, { address: add });
const getAddressError = (error) => createAction(GET_ADDRESS_ERROR, { error });
const getAddressReset = () => createAction(GET_ADDRESS_RESET);

const createAddress = ({ unitNo, fullAddress, postCode, default: df }) =>
  createAction(CREATE_ADDRESS, { unitNo, fullAddress, postCode, default: df });
const createAddressSuccess = (add) =>
  createAction(CREATE_ADDRESS_SUCCESS, { address: add });
const createAddressError = (error) =>
  createAction(CREATE_ADDRESS_ERROR, { error });
const createAddressReset = () => createAction(CREATE_ADDRESS_RESET);

const updateAddress = (data) =>
  createAction(UPDATE_ADDRESS, {
    data,
  });
const updateAddressSuccess = (add) =>
  createAction(UPDATE_ADDRESS_SUCCESS, { address: add });
const updateAddressError = (error) =>
  createAction(UPDATE_ADDRESS_ERROR, { error });
const updateAddressReset = () => createAction(UPDATE_ADDRESS_RESET);

module.exports = {
  getAddress,
  getAddressSuccess,
  getAddressError,
  getAddressReset,

  createAddress,
  createAddressSuccess,
  createAddressError,
  createAddressReset,

  updateAddress,
  updateAddressSuccess,
  updateAddressError,
  updateAddressReset,
};
